import { lazy, Route } from '@tanstack/router'

import type { CasinoSearch } from '../../types/route-search'
import { casinoRoute } from '.'

const Casino = lazy(() => import('../../pages/casino'))

export const casinoCategoryRoute = new Route({
  getParentRoute: () => casinoRoute,
  path: '$category',
  component: Casino,
  validateSearch: (search: Record<string, unknown>): CasinoSearch => {
    return {
      platform: typeof search.platform === 'string' ? search.platform : '',
      error: typeof search.error === 'string' ? search.error : '',
      message: typeof search.message === 'string' ? search.message : '',
    }
  },
})
